import DeprecatedSelect, { SelectOption, DeprecatedSelectProps } from './deprecated-select';

export type { SelectOption, DeprecatedSelectProps };
export default DeprecatedSelect;
